import { render } from "./honoreeFilter.vue?vue&type=template&id=35ea5310"
import script from "./honoreeFilter.vue?vue&type=script&lang=js"
export * from "./honoreeFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__